/**
 * Shared parsing for GET /club/employee/club/:clubId/employees responses.
 */

export function asClubEmployeesList(raw, depth = 0) {
  if (raw == null || depth > 6) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw !== "object") return [];

  const arrayKeys = [
    "employees",
    "items",
    "result",
    "results",
    "rows",
    "list",
    "users",
    "staff",
    "records",
    "data",
  ];
  for (let i = 0; i < arrayKeys.length; i += 1) {
    const v = raw[arrayKeys[i]];
    if (Array.isArray(v)) return v;
  }

  if (raw.data != null && typeof raw.data === "object") {
    const nested = asClubEmployeesList(raw.data, depth + 1);
    if (nested.length > 0) return nested;
  }

  return [];
}

export function pickClubEmployeeUserId(r) {
  if (!r || typeof r !== "object") return "";
  const u = r.user;
  if (typeof u === "string" && u.trim()) return u.trim();
  if (u && typeof u === "object") {
    const id = u._id ?? u.id;
    if (id != null && id !== "") return String(id);
  }
  const direct =
    r.userId ??
    r.userid ??
    r.userID ??
    r.employeeUserId ??
    r.user_id ??
    r.soldByUserId;
  if (direct != null && direct !== "") return String(direct);
  if (r._id != null && r._id !== "") {
    const looksLikeMembership =
      r.clubId != null || r.club_id != null || r.club != null;
    if (!looksLikeMembership && (r.email || r.fullname || r.name)) {
      return String(r._id);
    }
  }
  return "";
}

function pickEmployeeNamePart(r, key) {
  if (!r || typeof r !== "object") return "";
  const fromUser =
    r.user && typeof r.user === "object" ? r.user[key] : undefined;
  const v = r[key] ?? fromUser;
  return v != null && v !== "" ? String(v).trim() : "";
}

/** Display name from firstname + lastname, else fullname / legacy name. */
export function formatClubEmployeeDisplayName(r) {
  const first = pickEmployeeNamePart(r, "firstname");
  const last = pickEmployeeNamePart(r, "lastname");
  if (first || last) return [first, last].filter(Boolean).join(" ");
  return String(
    r?.fullname ?? r?.name ?? r?.user?.fullname ?? ""
  ).trim();
}

export function pickClubEmployeeEmpref(r) {
  if (!r || typeof r !== "object") return "";
  const v = r.empref ?? r.empRef ?? r.emp_ref;
  if (v != null && String(v).trim() !== "") return String(v).trim();
  const u = r.user;
  if (u && typeof u === "object") {
    const fromUser = u.empref ?? u.empRef ?? u.emp_ref;
    if (fromUser != null && String(fromUser).trim() !== "") {
      return String(fromUser).trim();
    }
  }
  return "";
}

export function formatClubEmployeeOptionLabel(r) {
  const name = formatClubEmployeeDisplayName(r);
  const email = String(r?.email ?? r?.user?.email ?? "").trim();
  const empref = pickClubEmployeeEmpref(r);
  if (name && empref) return `${name} (${empref})`;
  if (name && email) return `${name} (${email})`;
  if (name) return name;
  if (empref) return empref;
  if (email) return email;
  const id = pickClubEmployeeUserId(r);
  return id || "—";
}
